import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect } from "react";
import { AppFormContext } from "../../App";
import { useFocusElement } from "@brushfire/ui";
var getFieldErrorNames = function (formikErrors) {
    var transformObjectToDotNotation = function (obj, prefix, result) {
        if (prefix === void 0) { prefix = ""; }
        if (result === void 0) { result = []; }
        Object.keys(obj).forEach(function (key) {
            var value = obj[key];
            if (!value)
                return;
            var nextKey = prefix ? "".concat(prefix, ".").concat(key) : key;
            if (typeof value === "object") {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                //@ts-ignore
                transformObjectToDotNotation(value, nextKey, result);
            }
            else {
                result.push(nextKey);
            }
        });
        return result;
    };
    return transformObjectToDotNotation(formikErrors);
};
var FormikContextListener = function (_a) {
    var _b, _c;
    var formikContext = _a.formikContext, path = _a.path, currentPath = _a.currentPath, _d = _a.active, active = _d === void 0 ? false : _d, timesLoaded = _a.timesLoaded, initialValues = _a.initialValues, focusDelay = _a.focusDelay;
    var _e = useContext(AppFormContext), existingFormikContext = _e.formikContext, setFormikContext = _e.setFormikContext;
    var focusElement = useFocusElement();
    var submitCount = formikContext.submitCount, isValid = formikContext.isValid, errors = formikContext.errors;
    useEffect(function () {
        if (timesLoaded && initialValues) {
            formikContext.resetForm({ values: initialValues, isSubmitting: formikContext.isSubmitting });
        }
    }, [timesLoaded]);
    useEffect(function () {
        if (isValid)
            return;
        var fieldErrorNames = getFieldErrorNames(errors);
        if (fieldErrorNames.length <= 0)
            return;
        setTimeout(function () {
            console.log(fieldErrorNames[0]);
            var element = document.querySelector("input[name='".concat(fieldErrorNames[0], "'], div[data-field-error-name='").concat(fieldErrorNames[0], "']"));
            if (!element)
                return;
            // Scroll to first known error into view
            element.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 400);
    }, [submitCount]);
    useEffect(function () {
        if (!!Object.keys(formikContext.errors).length) {
            var formError = document.getElementById("form-error");
            if (formError) {
                focusElement(formError, focusDelay);
            }
            else {
                var target = document.getElementById(Object.keys(formikContext.errors)[0]);
                focusElement(target, focusDelay);
            }
        }
    }, [formikContext.isSubmitting]);
    useEffect(function () {
        if ((currentPath === path || (Array.isArray(path) && path.includes(currentPath))) &&
            setFormikContext &&
            (existingFormikContext !== formikContext ||
                (formikContext === null || formikContext === void 0 ? void 0 : formikContext.dirty) ||
                existingFormikContext.isSubmitting !== formikContext.isSubmitting) &&
            active) {
            setFormikContext(formikContext);
        }
    }, [currentPath, setFormikContext, active, formikContext === null || formikContext === void 0 ? void 0 : formikContext.dirty, formikContext === null || formikContext === void 0 ? void 0 : formikContext.isSubmitting].concat(Object.values((_c = (_b = formikContext === null || formikContext === void 0 ? void 0 : formikContext.status) === null || _b === void 0 ? void 0 : _b.bag) !== null && _c !== void 0 ? _c : {})));
    return _jsx(_Fragment, {});
};
export default FormikContextListener;
